export default __webpack_public_path__ + "static/media/notices-icon-active.63389f3e.svg";